<template>
  <div style="margin: 0 5%">
    <h1 style="font-weight: bold">添加事务</h1>
    <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules"
                  :style="{background:'url('+imagePath+')'}"
                  style="padding: 5%">
      <a-form-model-item label="单据编号" required prop="fbillno">
        <a-input v-model="form.fbillno" placeholder="输入单据编号" disabled/>
      </a-form-model-item>
      <a-form-model-item label="创建人" required prop="fcreateuser" has-feedback>
        <a-input v-model="form.fcreateuser" placeholder="输入创建人" :disabled="fcreateuserDisabled"/>
      </a-form-model-item>
      <a-form-model-item label="数量">
        <a-input v-model="form.fqty" placeholder="输入数量"/>
      </a-form-model-item>
      <a-form-model-item label="事务类型" required prop="fposttype" has-feedback>
        <a-select v-model="form.fposttype" @change="handleChange">
          <a-select-option v-for="fposttype in fposttypes" :key="fposttype.fposttypeid">
            {{ fposttype.fposttypename }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="事务分类" required prop="fspecificationtype" has-feedback>
        <a-select v-model="form.fspecificationtype">
          <a-select-option v-for="fspecificationtype in fspecificationtypes"
                           :key="fspecificationtype.fspecificationtypeid">
            {{ fspecificationtype.fspecificationtypename }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="事务描述" required prop="fspecification" v-show="seen" has-feedback>
        <a-input v-model="form.fspecification" type="textarea" placeholder="输入事务描述"/>
      </a-form-model-item>
      <a-form-model-item label="结案人" required prop="fproxycloseuser" v-show="seen" has-feedback>
        <a-input v-model="form.fproxycloseuser" placeholder="输入结案人"/>
      </a-form-model-item>
      <a-form-model-item label="是否创建单据">
        <a-radio-group name="radioGroup" v-model="form.flag">
          <a-radio :value="1">
            是
          </a-radio>
          <a-radio :value="0">
            否
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 12}">
        <a-button type="primary" @click="onSubmit(form.fbillno)">
          <div style="font-family: 微软雅黑;font-weight: bold">提交</div>
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "schmearpostCreate",
  data() {
    return {
      imagePath: require('../assets/bj7.jpg'),
      seen: true,
      fcreateuserDisabled: false,
      fposttypes: '',
      fspecificationtypes: '',
      labelCol: {span: 4},
      wrapperCol: {span: 8},
      form: {
        fbillno: this.$route.query.fbillno,
        fcreateuser: '',
        fqty: '',
        fposttype: '',
        fspecificationtype: '',
        fspecification: '',
        fproxycloseuser: '',
        flag: 1,
      },
      rules: {
        fbillno: [
          {required: true, message: '单据编号不能为空', trigger: 'change'},
        ],
        fcreateuser: [
          {required: true, message: '创建人不能为空', trigger: 'change'},
        ],
        fposttype: [
          {required: true, message: '事务类型不能为空', trigger: 'change'},
        ],
        fspecificationtype: [
          {required: true, message: '事务分类不能为空', trigger: 'change'},
        ],
        fspecification: [
          {required: true, message: '事务描述不能为空', trigger: 'change'},
        ],
        fproxycloseuser: [
          {required: true, message: '结案人不能为空', trigger: 'change'},
        ],
      },
    };
  },
  mounted() {
    axios.get("http://www.tcnanhua.com:5555/t-posttype/selectAll")
      .then((res) => {
        this.fposttypes = res.data.data;
      });
    axios.get("http://www.tcnanhua.com:5555/t-specificationtype/selectAll")
      .then((res) => {
        this.fspecificationtypes = res.data.data;
      });
    axios.get("http://www.tcnanhua.com:5555/user/getUserName?code=" + this.$route.query.code)
      .then((res) => {
        this.form.fcreateuser = res.data.data;
        if (this.form.fcreateuser != null && this.form.fcreateuser != "" && this.form.fcreateuser != undefined) {
          this.fcreateuserDisabled = true;
        }
      });
  },
  methods: {
    handleChange() {
      if (this.form.fposttype === "1001") {
        this.seen = false;
      } else {
        this.form.fproxycloseuser = "";
        this.form.fspecification = "";
        this.seen = true;
      }
    },
    onSubmit(fbillno) {
      this.$message.loading('提交中...');
      if (this.form.flag == 0)
        this.form.fqty = 0;
      if (this.form.fposttype === "1001") {
        this.form.fspecification = this.form.fspecificationtype;
        this.form.fproxycloseuser = this.form.fcreateuser;
      }
      if (this.form.fcreateuser == "") {
        alert("创建人必填");
        return;
      }
      if (this.form.fposttype == "") {
        alert("事务类型必填");
        return;
      }
      if (this.form.fspecificationtype == "") {
        alert("事务分类必填");
        return;
      }
      if (this.form.fspecification == "") {
        alert("事务描述必填");
        return;
      }
      if (this.form.fproxycloseuser == "") {
        alert("结案人必填");
        return;
      }
      axios.get("http://www.tcnanhua.com:5555/t-schmearpost/insert?fbillno=" + this.form.fbillno + "&fcreateuser=" + this.form.fcreateuser
        + "&fqty=" + this.form.fqty + "&fposttype=" + this.form.fposttype + "&fspecificationtype=" + this.form.fspecificationtype + "&fspecification=" + this.form.fspecification
        + "&fproxycloseuser=" + this.form.fproxycloseuser + "&flag=" + this.form.flag)
        .then((resp) => {
          this.code = resp.data.code;
          if (this.code == 1) {
            this.$message.success('提交成功,即将返回上一页,若未返回请手动返回');
          } else {
            this.$message.error('提交失败,请稍后再试,即将返回上一页,若未返回请手动返回');
          }
        });
      setTimeout(function () {
        location.replace("http://www.tcnanhua.com:5555/ui/schmearpost?fbillno=" + fbillno);
      }, 3000);
    },
  },
}
</script>

<style>
label {
  margin-right: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/SchmearpostCreate.vue